export const INITIAL_MODAL_WIDTH = 520;
export const INITIAL_MODAL_HEIGHT = 500;
export const MIN_MODAL_WIDTH = 300;
export const MIN_MODAL_HEIGHT = 200;
export const MODAL_RIGHT_OFFSET = 20;
export const MODAL_BOTTOM_OFFSET = 60;
export const UNIQ_MODAL_SIZE_STORAGE_KEY = "uniq_modal_size";
